<template>
  <div v-if="data.link !== undefined" class="cta">
    <IconLink :label="data.link.title" :url="data.link.uri.path" icon="CircleArrowRightFilled" />
  </div>
</template>

<script setup lang="ts">

const props = defineProps<{
  data: any
}>()

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.cta {
  @include tools.page-grid-columns;
}
</style>
